module.exports = __webpack_public_path__ + "img/DukeHealth.07432075.png";